<span class="badge-icon" *ngIf="icon" [inlineSVG]="icon"></span>
{{label}}

